<template>
    <div class="flex grow h-0 py-2">
        <div class="flex flex-col h-full w-full px-2 history-card">
            <card-form
                ref="cardFormRef"
                :meta="historyCardMeta"
                :toolbarShow="false"
                :use-default-buttons="true"
                :to-remove-toolbar-items-names="['copy', 'edit', 'delete', 'settings']"
                components-path="views/history/history-card/components"
                :callbacks="{ sendUserData, getUserData, isDirty: null }"
            />
            <HistoryGridResults />
        </div>
    </div>
</template>

<script>
export default {
    name: 'view-history',
};
</script>

<script setup>

import {
    ref,
    reactive,
    provide,
    watch,
    onMounted,
} from 'vue';

import cardForm from '@/components/card-component/card-form.vue';
import historyCardMeta from '@/views/history/history-card/history-card-meta';
import { getUserDataChanges, saveUserDataChanges } from '@/service/userdata-service';
import HistoryGridResults from '@/views/history/history-card/components/history-grid-results.vue';
import { ContextNames, getDefaultContextGroup } from '@/layouts/main-layout/main-layout-data';

const VIEW_ID = 'history-card';
let need_save_userdata = false;

const conditions = ref({ beg: null, end: null });
provide('conditions', reactive(conditions));

const search_args = reactive({ params: { first: true } });
provide('search_args', search_args);

// событие нажатия на кнопку "Искать"
const search_btn_clicks = ref(0);
provide('search_btn_clicks', search_btn_clicks);

const cardFormRef = ref(null);

// эта переменная меняется кнопкой "Искать"
const click_counter = ref(0);
provide('click_counter', click_counter);

const use_context = ref(false);
provide('use_context', use_context);

// триггер для кнопки
watch(
    [() => click_counter.value, () => use_context.value],
    async ([newCounterVal, newCtxVal], [oldCounterVal, oldCtxVal]) => {
        if (newCounterVal > oldCounterVal) {
            await sendUserData();
            search_args.args = buildRequestArgs(conditions.value, newCtxVal);
            if (search_args.params.first) {
                search_args.params.first = false;
            }
        }
    },
    { deep: false }
);

// здесь userData еще не доступна,
// поэтому только работа с интерфейсом
onMounted(async () => {
    changeApparence();
    // сохранять условия сразу не требуется
    setTimeout(() => {
        need_save_userdata = true;
    }, 3000);
});

// запомненные данные приходят здесь
const getUserData = async args => {
    args.viewId = VIEW_ID;
    const x = await getUserDataChanges(args);
    conditions.value = x.changes ?? {};
    console.log('history-card:getUserData userData:', x.changes);
    return [x.changes ?? {}];
};

const sendUserData = async () => {
    if (need_save_userdata) {
        const args = {
            viewId: VIEW_ID,
            changes: conditions.value,
        };

        if (conditions.value?.do_search) delete conditions.value.do_search;

        const answer = await saveUserDataChanges(args);
        return answer;
    } else {
        return null;
    }
};

const buildRequestArgs = (data, withContext) => {
    const cond = {
        dog_ctx: {},
        net_ctx: {},
    };
    if (data.who_id) {
        const parts = data.who_id.split(':');
        if (parts[1] === 'e') {
            cond.emp_id = parts[0];
        }
        if (parts[1] === 'd') {
            cond.dep_id = parts[0];
        }
    }
    if (data.where_id) {
        const parts = data.where_id.split(':');
        if (parts[0] === 't') {
            cond.tab_id = parts[2];
        }
        if (parts[0] === 'g') {
            cond.grp_id = parts[1];
        }
    }
    if (data.beg) cond.beg = data.beg;
    if (data.end) cond.end = data.end;

    cond.operation = data.oper ?? 'x';
    cond.dog_ctx = withContext ? getContext() : {};

    return cond;
};

const getContext = () => {
    const ctx = {};
    const orgContextGroup = getDefaultContextGroup(ContextNames.ORG_CONTEXT_GROUP);
    if (orgContextGroup?.contexts?.DogContext) {
        ctx.dog_id = orgContextGroup.contexts.DogContext.value;
    }
    if (orgContextGroup?.contexts?.NumObjContext) {
        ctx.obj_id = orgContextGroup.contexts.NumObjContext.value;
    }
    if (orgContextGroup?.contexts?.PointContext) {
        ctx.pnt_id = orgContextGroup.contexts.PointContext.value;
    }
    return ctx;
};

const changeApparence = () => {
    const card = document.querySelector('.history-card .ai-card');
    card.classList.remove('h-0');
    card.classList.remove('overflow-hidden');
    card.querySelector('.ai-card-scroll-panel').classList.remove('overflow-auto');
};

</script>

<style lang="scss">
.x-history-card .ai-card-group:first-child .ai-card-group-header {
    display: none !important;
}
.history-card .ai-card-group {
    margin: 0 !important;
}
.history-card .ai-card-toolbar-container {
    display: none !important;
}

.history-card .dx-list-item > .dx-inkripple > .dx-inkripple-wave {
    transition-property: none;
    transform: none;
    animation: none;
}

.x-history-card .ai-field-modified {
    background-color: #f6fafe;
}
</style>
